export class AwsNativeStandardBackupPolicyPlan {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "backupSchedules",
            "baseName": "backupSchedules",
            "type": "Array<AwsNativeStandardBackupSchedules>",
            "format": ""
        },
        {
            "name": "vaultProtectionMode",
            "baseName": "vaultProtectionMode",
            "type": "VaultProtectionMode",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsNativeStandardBackupPolicyPlan.attributeTypeMap;
    }
    constructor() {
    }
}
